import addToAttributesStore from "../../../../helpers/Attribute/addAttributesToStore";

const addAttributesResponder = (queryClient) => {
  return {
    onSuccess: (returnedData) => {
      addToAttributesStore({
        queryClient,
        attributes: returnedData,
      });
    },
    onError: (error) => {
      console.error("Failed to Add Attributes", error);
    },
  };
};

export default addAttributesResponder;
